import React from 'react'
import BackIcon from './BackIcon'
import styles from './BackButton.module.scss'
import { TutorialElementProps } from '../Tutorial/Tutorial'
import { tutorialDataTestIds } from '../mocks/tutorial-mocks'

type BackButtonProps = {
  backProps: TutorialElementProps
}

const BackButton = ({ backProps }: BackButtonProps) => (
  <button
    type="button"
    data-testid={tutorialDataTestIds.backButton}
    {...backProps}
    className={styles.backButton}
  >
    <BackIcon />
  </button>
)

export default BackButton
